export function retirarTagsHtml(texto?: string) {
  if (texto) {
    return texto.replace(/<[^>]*>/g, '')
  }
  return ''
}
